import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ChartersPage from './pages/ChartersPage';
import IslandAdventurePage from './pages/IslandAdventurePage';
import GalleryPage from './pages/GalleryPage';
import CabinBookingsPage from './pages/CabinBookingsPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminDashboard from './pages/AdminDashboard';
import OffSeasonPage from './pages/OffSeasonPage';

// ⚠️ JANUARY 2027 REMINDER: Set this to true to enable off-season page!
const OFF_SEASON_MODE = false;

// Layout wrapper for regular pages
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  
  return (
    <>
      {!isAdminPage && <Navigation />}
      {children}
      {!isAdminPage && <Footer />}
    </>
  );
};

// App wrapper to handle off-season mode
const AppContent = () => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  
  // If off-season mode and NOT admin page, show off-season page
  if (OFF_SEASON_MODE && !isAdminPage) {
    return <OffSeasonPage />;
  }
  
  // Admin page - always accessible
  if (isAdminPage) {
    return <AdminDashboard />;
  }
  
  // Normal site (when OFF_SEASON_MODE is false)
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/charters" element={<ChartersPage />} />
        <Route path="/island-adventure" element={<IslandAdventurePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/cabins" element={<CabinBookingsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<AppContent />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
